import { getUserProfile } from '@/api/user';
import { resolveDepositCountryCodeFromProfile } from '@/utils/deposit-geo-country';

/**
 * @typedef {'profile' | 'loginIp' | 'currentIp' | 'none'} DepositGeoSource
 */

/**
 * @typedef {{
 *   profile: object | null,
 *   countryCode: string | null,
 *   source: DepositGeoSource,
 * }} DepositGeoSession
 */

/** @type {Promise<DepositGeoSession> | null} */
let sessionPromise = null;

export function resetDepositGeoSession() {
  sessionPromise = null;
}

/**
 * 会话内单次 profile + geo 解析（in-flight 去重）。
 * @param {{ force?: boolean }} [options]
 * @returns {Promise<DepositGeoSession>}
 */
export function resolveDepositGeoSession({ force = false } = {}) {
  if (!force && sessionPromise) return sessionPromise;

  sessionPromise = (async () => {
    const profile = await getUserProfile().catch(() => null);
    const geo = await resolveDepositCountryCodeFromProfile(profile);
    return {
      profile,
      countryCode: geo.countryCode,
      source: geo.source,
    };
  })();

  return sessionPromise;
}
